import { z } from "zod";

import { ExperienceDto, ExperienceDtoSchema } from "../../../dtos/experiences";

export const GetExperienceRequestPathParamSchema = z.object({
  experienceId: z.string().uuid(),
});

export type GetExperienceRequestPathParamType = z.infer<
  typeof GetExperienceRequestPathParamSchema
>;

export const GetExperienceResponseBodySchema = z.object({
  experience: ExperienceDtoSchema,
});

export type GetExperienceResponseBodyType = {
  experience: ExperienceDto;
};
